import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "../constants/endpointsURL";
import { PKTemplateRule } from "./models/template-rules.model";

@Injectable({
  providedIn: "root",
})
export class TemplateRulesService {
  env = environment.env;
  maintenanceTemplatesRulesURL = endpointsURL.maintenanceTemplatesRulesURL;

  typeOfDocumentSelected: any = {
    tipoCertificado: "0",
  };

  constructor(private httpClient: HttpClient) {}

  setTypeOfDocumentSelected(itemSelected: any): void {
    this.typeOfDocumentSelected = itemSelected;
  }

  getTypeOfDocumentSelected(): any {
    return this.typeOfDocumentSelected;
  }

  public listaReglasPlantilla(filters: string, idTypeDocument: any): any {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}/lista?_tipoCertificado=${idTypeDocument["tipoCertificado"]}&_tipoReforma=${idTypeDocument["tipoReforma"]}&${filters}`
    );
  }
  public getRuleTemplate(id: PKTemplateRule): any {
    let params = new HttpParams().set("_identificador", JSON.stringify(id));

    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}`,
      {
        params: params,
      }
    );
  }

  public removeRuleTemplate(ids: PKTemplateRule[]): any {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}/remove`,
      ids
    );
  }

  public createRuleTemplate(ruleTemplate: any): any {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}`,
      ruleTemplate
    );
  }

  public updateRuleTemplate(ruleTemplate: any): any {
    return this.httpClient.put<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}`,
      ruleTemplate
    );
  }

  public validateEcuacion(ecuacion: string) {
    let params = new HttpParams().set("_ecuacion", ecuacion);

    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}/validateEcuacion`,
      { params: params }
    );
  }

  public moveUpDown(move: string, id: PKTemplateRule) {
    let params = new HttpParams();
    params = params.append("_indice", id.reIndice.toString());
    params = params.append("_marcoLegal", id.reMarcolegal);
    params = params.append("_orden", move);
    params = params.append("_reforma", id.reReforma);
    params = params.append("_tCertificado", id.reTcertificado);

    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceTemplatesRulesURL}/mover`,
      {
        params: params,
      }
    );
  }
}
